import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import LeaveForm from "./LeaveForm";
import Listprint from "../../Listprint";
class Leave extends Component {
  state = {
    isModal: false,
    loading: true,
    loadError: "",
    formData: "",
    search: "",
    leaves: [],
    columns: [
      { label: "Matricule", field: "matricule", sort: "asc", width: 110 },
      { label: "Personnel", field: "staff", sort: "asc", width: 220 },
      { label: "Motif", field: "reason", sort: "asc", width: 240 },
      { label: "Période", field: "period", sort: "asc", width: 190 },
      { label: "Durée", field: "duration", sort: "asc", width: 90 },
      {
        label: "",
        field: "action",
        sort: "disabled",
        width: 100,
        printable: false,
      },
    ],
  };

  componentDidMount() {
    this.getLeaves();
  }

  getLeaves = async () => {
    this.setState({ loading: true, loadError: "" });

    try {
      const response = await axios.get("leaves");
      this.setState({
        leaves: Array.isArray(response.data) ? response.data : [],
      });
    } catch (error) {
      this.setState({
        loadError: "Impossible de charger la liste des congés.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  showModal = (leave = null) => {
    this.setState(
      (state) => ({
        isModal: !state.isModal,
        formData: state.isModal ? "" : leave,
      }),
      () => {
        if (!this.state.isModal) this.getLeaves();
      }
    );
  };

  delete = async (leave) => {
    const staffName = this.getStaffName(leave) || "ce membre du personnel";

    if (
      !window.confirm(
        `Supprimer définitivement le congé de « ${staffName} » ?`
      )
    ) {
      return;
    }

    try {
      const response = await axios.delete(`leaves/${leave.id}`);
      toast.success(response?.data?.msg || "Le congé a été supprimé.");
      this.getLeaves();
    } catch (error) {
      toast.error(error.response?.data?.msg || "La suppression a échoué.");
    }
  };

  can = (permission) => {
    try {
      return JSON.parse(localStorage.getItem("permissions") || "[]").some(
        (item) => permission === item.permission
      );
    } catch (error) {
      return false;
    }
  };

  getStaffName = (leave) => {
    const user = leave?.staff?.user || {};

    return [user.last_name, user.family_name, user.first_name]
      .filter(Boolean)
      .join(" ")
      .trim();
  };

  getInitials = (leave) => {
    const name = this.getStaffName(leave) || leave?.staff?.matricule || "RH";

    return name
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part.charAt(0))
      .join("")
      .toUpperCase();
  };

  toDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  formatDate = (value) => {
    const date = this.toDate(value);

    return date
      ? new Intl.DateTimeFormat("fr-FR", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }).format(date)
      : "Non renseignée";
  };

  getDuration = (leave) => {
    const start = this.toDate(leave?.date_start);
    const end = this.toDate(leave?.date_end);

    if (!start || !end || end < start) return 0;
    return Math.floor((end - start) / 86400000) + 1;
  };

  getStatus = (leave) => {
    const start = this.toDate(leave?.date_start);
    const end = this.toDate(leave?.date_end);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (!start || !end) return "unknown";
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    if (today < start) return "upcoming";
    if (today > end) return "past";
    return "current";
  };

  matches = (leave, query) => {
    if (!query) return true;

    return [
      leave?.staff?.matricule,
      this.getStaffName(leave),
      leave?.reason,
      this.formatDate(leave?.date_start),
      this.formatDate(leave?.date_end),
    ]
      .filter(Boolean)
      .some((value) =>
        String(value).toLocaleLowerCase("fr").includes(query)
      );
  };

  rows = (leaves) =>
    leaves.map((leave) => {
      const staff = leave?.staff;
      const user = staff?.user || {};
      const staffName = this.getStaffName(leave) || "Personnel non renseigné";
      const duration = this.getDuration(leave);
      const status = this.getStatus(leave);

      return {
        matricule: staff ? (
          <Link to={`/staffs/${staff.id}`} className="staff-table-matricule">
            {staff.matricule || "Sans matricule"}
          </Link>
        ) : (
          <em>Indisponible</em>
        ),

        staff: (
          <span className="staff-table-person">
            <span className="staff-table-avatar">
              {user.avatar ? (
                <img src={user.avatar} alt="" />
              ) : (
                <i>{this.getInitials(leave)}</i>
              )}
            </span>
            <span>
              <b>{staffName}</b>
              <small>{user.email || user.tel || "Coordonnées non renseignées"}</small>
            </span>
          </span>
        ),

        reason: (
          <span className="leave-table-reason">
            <b>{leave.reason || "Motif non renseigné"}</b>
            <small className={`leave-status leave-status--${status}`}>
              {status === "current"
                ? "En cours"
                : status === "upcoming"
                ? "À venir"
                : status === "past"
                ? "Terminé"
                : "Dates à vérifier"}
            </small>
          </span>
        ),

        period: (
          <span className="leave-table-period">
            <span>
              <FeatherIcon icon="log-in" size={13} />
              {this.formatDate(leave.date_start)}
            </span>
            <span>
              <FeatherIcon icon="log-out" size={13} />
              {this.formatDate(leave.date_end)}
            </span>
          </span>
        ),

        duration: (
          <span className="leave-duration">
            {duration || "—"}
            <small>{duration > 1 ? "jours" : duration === 1 ? "jour" : ""}</small>
          </span>
        ),

        action: (
          <span className="staff-table-actions">
            {this.can("Modifier congé") && (
              <button
                type="button"
                onClick={() => this.showModal(leave)}
                title="Modifier ce congé"
              >
                <FeatherIcon icon="edit-3" size={15} />
              </button>
            )}
            {this.can("Supprimer congé") && (
              <button
                type="button"
                className="danger"
                onClick={() => this.delete(leave)}
                title="Supprimer ce congé"
              >
                <FeatherIcon icon="trash-2" size={15} />
              </button>
            )}
          </span>
        ),
      };
    });

  render() {
    const query = this.state.search.trim().toLocaleLowerCase("fr");
    const leaves = [...this.state.leaves]
      .sort(
        (a, b) =>
          (this.toDate(b.date_start)?.getTime() || 0) -
          (this.toDate(a.date_start)?.getTime() || 0)
      )
      .filter((leave) => this.matches(leave, query));
    const current = this.state.leaves.filter(
      (leave) => this.getStatus(leave) === "current"
    ).length;
    const upcoming = this.state.leaves.filter(
      (leave) => this.getStatus(leave) === "upcoming"
    ).length;
    const totalDays = this.state.leaves.reduce(
      (total, leave) => total + this.getDuration(leave),
      0
    );

    return (
      <main className="container staff-page leave-page">
        <Helmet>
          <title>{process.env.REACT_APP_NAME} | Congés</title>
        </Helmet>

        <header className="staff-header leave-header">
          <div>
            <span>
              <FeatherIcon icon="calendar" size={14} />
              Gestion du personnel
            </span>
            <h1>Congés du personnel</h1>
            <p>
              Planifiez les absences et gardez une vue claire sur les périodes
              de congé.
            </p>
          </div>

          <nav>
            <Link to="/manuel#leaves" className="btn btn-light">
              <FeatherIcon icon="book-open" size={17} /> Doc
            </Link>
            {this.can("Ajouter congé") && (
              <button type="button" onClick={() => this.showModal(null)}>
                <FeatherIcon icon="plus" size={18} />
                Nouveau congé
              </button>
            )}
          </nav>
        </header>

        <section className="staff-stats" aria-label="Résumé des congés">
          <article>
            <i><FeatherIcon icon="calendar" /></i>
            <b>{this.state.leaves.length}<small>Congés enregistrés</small></b>
          </article>
          <article>
            <i><FeatherIcon icon="clock" /></i>
            <b>{current}<small>Congés en cours</small></b>
          </article>
          <article>
            <i><FeatherIcon icon="arrow-right-circle" /></i>
            <b>{upcoming}<small>Congés à venir</small></b>
          </article>
          <article>
            <i><FeatherIcon icon="sun" /></i>
            <b>{totalDays}<small>Jours planifiés</small></b>
          </article>
        </section>

        <section className="staff-panel">
          <div className="staff-toolbar">
            <div>
              <span>Planning des absences</span>
              <h2>Congés enregistrés</h2>
            </div>

            <label>
              <FeatherIcon icon="search" size={16} />
              <input
                type="search"
                value={this.state.search}
                onChange={(event) =>
                  this.setState({ search: event.target.value })
                }
                placeholder="Personnel, matricule, motif…"
              />
              {this.state.search && (
                <button
                  type="button"
                  onClick={() => this.setState({ search: "" })}
                  title="Effacer la recherche"
                >
                  <FeatherIcon icon="x" size={14} />
                </button>
              )}
            </label>
          </div>

          {this.state.loading ? (
            <div className="staff-state"><FeatherIcon className="user-search-spin" icon="loader" /></div>
          ) : this.state.loadError ? (
            <div className="staff-state error">
              <FeatherIcon icon="alert-circle" />
              <h3>Liste indisponible</h3>
              <p>{this.state.loadError}</p>
              <button type="button" onClick={this.getLeaves}>Réessayer</button>
            </div>
          ) : leaves.length ? (
            <div className="staff-list leave-list">
              <Listprint
                columns={this.state.columns}
                rows={this.rows(leaves)}
                title="Liste des congés"
              />
            </div>
          ) : (
            <div className="staff-state">
              <FeatherIcon icon={query ? "search" : "calendar"} />
              <h3>{query ? "Aucun résultat" : "Aucun congé enregistré"}</h3>
              <p>
                {query
                  ? "Essayez avec un autre personnel, matricule ou motif."
                  : "Les congés ajoutés apparaîtront ici avec leur période."}
              </p>
            </div>
          )}
        </section>

        <LeaveForm
          isModal={this.state.isModal}
          formData={this.state.formData}
          showModal={this.showModal}
        />
      </main>
    );
  }
}

export default Leave;
